import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { CoinIcon } from '@/components/wallets';

import { formatAmount } from '@/helpers/coins';
import type { WalletCoin } from '@/types';
import type { StackProps } from '@mui/material';

type CoinInfoProps = {
  coin: WalletCoin;
} & StackProps;

export const CoinInfo = ({ coin, ...viewProps }: CoinInfoProps) => {
  const { ticker, chain, wallet, is_wallet_configured, decimals } = coin;
  const subtitle = useMemo(() => {
    if (!is_wallet_configured || !wallet) return 'Wallet Not Configured';
    const balance = wallet.last_balance ?? 0;
    const { formatted } = formatAmount(balance, decimals, 8);
    return `${formatted} ${ticker}`;
  }, [is_wallet_configured, wallet, ticker, decimals]);

  return (
    <Stack direction="row" alignItems="center" gap={2} {...viewProps}>
      <CoinIcon coin={coin} />
      <Stack sx={{ flex: 1 }}>
        <Typography variant="body1" fontWeight="bold">
          <Typography sx={{ opacity: 0.6 }} component="span" variant="body2">
            {chain.name} /{' '}
          </Typography>
          {ticker}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.6 }}>
          {subtitle}
        </Typography>
      </Stack>
    </Stack>
  );
};
